import {
  createCsrfMiddleware,
  createMiddleware,
  createStart,
} from "@tanstack/react-start";

const disabledApiPrefix = "/api/v1";

function isDisabledApiPath(pathname: string) {
  return (
    pathname === disabledApiPrefix ||
    pathname.startsWith(`${disabledApiPrefix}/`)
  );
}

const disableUnreleasedApiMiddleware = createMiddleware({
  type: "request",
}).server(({ pathname, next }) => {
  if (!isDisabledApiPath(pathname)) {
    return next();
  }

  return Response.json(
    {
      error: {
        code: "NOT_FOUND",
        message: "Not found",
      },
    },
    {
      status: 404,
      headers: {
        "Cache-Control": "private, no-store",
      },
    },
  );
});

const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => ({
  requestMiddleware: [csrfMiddleware, disableUnreleasedApiMiddleware],
}));
